import { Backdrop, Stack, Zoom } from "@mui/material";
import Lottie from "lottie-react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { PLUGIN_NAME } from "config/const";

import loadingMyBee from "../assets/lotti/mybee.json";
import loadingEnergy from "../assets/lotti/Energy.json";
import loadingMeter from "../assets/lotti/meter.json";
import loadingService from "../assets/lotti/service.json";

const Loading = () => {
  const showLoading = useSelector((state) => state?.sys.showLoading);
  const selectedPlugin = useSelector((state) => state?.userSettings?.selectedPlugin);
  const [open, setOpen] = useState(false);
  const [lotti, setLotti] = useState(null);

  useEffect(() => {
    if (showLoading) {
      if (selectedPlugin === PLUGIN_NAME.SERVICES_CALL) {
        setLotti(loadingService);
      } else if (selectedPlugin === PLUGIN_NAME.MICRO_CONTROLLERS) {
        setLotti(loadingEnergy);
      } else if (selectedPlugin === PLUGIN_NAME.METER_READ) {
        setLotti(loadingMeter);
      } else {
        setLotti(loadingMyBee);
      }
      setOpen(true);
    }
    else {
      setLotti(null);
      setOpen(false);
    }
  }, [showLoading, selectedPlugin]);

  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 500,
        "&.MuiBackdrop-root": {
          bgcolor: "rgba(0 , 0, 0, 0.1)",
          backdropFilter: "blur(2px)",
        },
      }}
      open={open && lotti}
    >
      <Zoom in={open && lotti}>
        <Stack
          bgcolor="white"
          alignItems="center"
          justifyContent="center"
          borderRadius={100}
          paddingTop={1}
          paddingX={1}
          maxWidth={170}
        >
          <Lottie animationData={lotti} loop={true} />
        </Stack>
      </Zoom>
    </Backdrop>
  );
};
export default Loading;
